import { getToken } from "firebase/messaging";
import { messaging } from "../services/firebase";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { auth, db } from "../services/firebase";
import { onAuthStateChanged } from "firebase/auth";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.warn("Notification permission denied");
      return;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY,
    });

    // console.log("FCM Token:", token);

    // Wait for auth state to be ready
    onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.warn("User not authenticated. Cannot save FCM token.");
        return;
      }

      const userRef = doc(db, "users", user.uid);

      try {
        await updateDoc(userRef, {
          fcmTokens: arrayUnion(token),
        });
        // console.log("FCM token saved to Firestore.");
      } catch (error) {
        console.error("Error saving token to Firestore:", error);
      }
    });
  } catch (error) {
    console.error("Error getting notification permission or token:", error);
  }
};
